var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_782_8473)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.625C5.58375 0.625 3.625 2.58375 3.625 5C3.625 7.41625 5.58375 9.375 8 9.375C10.4162 9.375 12.375 7.41625 12.375 5C12.375 2.58375 10.4162 0.625 8 0.625ZM5.375 5C5.375 3.55025 6.55025 2.375 8 2.375C9.44975 2.375 10.625 3.55025 10.625 5C10.625 6.44975 9.44975 7.625 8 7.625C6.55025 7.625 5.375 6.44975 5.375 5Z",
    fill: "#232A2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10.625C4.00338 10.625 3.02983 10.976 2.29736 11.6271C1.56153 12.2811 1.125 13.1919 1.125 14.1667V15.5C1.125 15.9832 1.51675 16.375 2 16.375C2.48325 16.375 2.875 15.9832 2.875 15.5V14.1667C2.875 13.727 3.07061 13.2812 3.46 12.935C3.85275 12.5859 4.40532 12.375 5 12.375H11C11.5947 12.375 12.1473 12.5859 12.54 12.935C12.9294 13.2812 13.125 13.727 13.125 14.1667V15.5C13.125 15.9832 13.5168 16.375 14 16.375C14.4832 16.375 14.875 15.9832 14.875 15.5V14.1667C14.875 13.1919 14.4385 12.2811 13.7026 11.6271C12.9702 10.976 11.9966 10.625 11 10.625H5Z",
    fill: "#232A2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_782_8473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.c3cced08491206be56b3e1ed37984f5e.svg";
export { ForwardRef as ReactComponent };